export default {
  title: 'Zamówienie nr {{number}}',
  labels: {
    item: '{{count}} produkt',
    item_other: '{{count}} produktów',
  },
  buttons: {
    details: 'Szczegóły',
  },
  fulfillment_statuses: {
    created: 'Złożone',
    reviewed: 'Sprawdzone',
    accepted: 'Przyjęte',
    preparing: 'W przygotowaniu',
    ready: 'Gotowe',
    on_delivery: 'W dostawie',
    picked: 'Odebrane',
    rejected: 'Odrzucone',
  },
};
